module.exports = __webpack_public_path__ + "img/staff-placeholder.7a3f83fa.jpg";